/**
 * class for the systemHeader that appears in documents
 */
export class SystemHeader {
    summaryName?: string;
    summaryDescription?: string;
    systemType?: string;
    templateId?: string;
    versionId?: string;
    previousVersionId?: string;
    createdWith?: string;
    excludeGeneralSearch?: boolean;
    currentVersion?: boolean;
    createdDate?: Date;
    serverCreatedDate?: Date;
    serverUpdatedDate?: Date;
    createdBy?: string;
    keyIds?: [string];
}
